import {
  TOGGLE_CONVERTIBLE_TOP,
  TOGGLE_PRIMARY_IMAGE_STATE,
  UPDATE_EXTERIOR_INDEX,
  UPDATE_INTERIOR_INDEX,
} from '../actionTypes';

export const updateInteriorIndex = (index) => ({
  type: UPDATE_INTERIOR_INDEX,
  payload: index,
});

export const updateExteriorIndex = (index) => ({
  type: UPDATE_EXTERIOR_INDEX,
  payload: index,
});

export const toggleConvertibleTop = () => ({
  type: TOGGLE_CONVERTIBLE_TOP,
});

export const togglePrimaryImageState = () => ({
  type: TOGGLE_PRIMARY_IMAGE_STATE,
});
